<template>
  <div>
    <custom-actions :has-header="!isChoose" :panel="!isChoose" :title="isChoose ? '选择品种规格' : '品种规格列表'">
      <template v-if="!isChoose" #header>
        <el-button type="primary" @click="changeText">商品介绍</el-button>
        <el-button type="primary" @click="showForm(null)">新增</el-button>
      </template>

      <el-form v-if="!isChoose" key="2" :model="searchForm" ref="formData" inline
        class="global-form-label-width account-form" label-width="100px">
        <el-form-item label="" prop="specName">
          <el-input clearable v-model="searchForm.specName" placeholder="请输入品种规格" />
        </el-form-item>
        <!-- <el-form-item label="类型名称" prop="typeName">
          <el-input clearable v-model="searchForm.typeName" placeholder="请输入类型名称" />
        </el-form-item> -->
        <el-form-item prop="productCode">
          <!-- <el-select filterable clearable v-model="searchForm.productCode" placeholder="请选择商品编号">
            <el-option v-for="(item, index) of productCodeList" :value="item.dicCode" :label="item.dicValue"
              :key="index"></el-option>
          </el-select> -->
          <el-input clearable v-model="searchForm.productCode" placeholder="请输入商品编号" />
        </el-form-item>
        <el-form-item label="" prop="isBulkOil">
          <el-select v-model="searchForm.isBulkOil" clearable placeholder="请选择是否散油">
            <el-option :value="item.value" :label="item.label" v-for="(item, index) of isBulkOilArr"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="isDisplay">
          <el-select v-model="searchForm.isDisplay" clearable placeholder="是否展示">
            <el-option value="1" label="是"></el-option>
            <el-option value="2" label="否"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <div class="wrap">
        <div class="left-tree">
          <div class="title">粮油类型</div>
          <el-tree :data="typeTreeList" :expand-on-click-node="false" :props="defaultProps"
            @node-click="handleNodeClick"></el-tree>
        </div>
        <div class="right-table">
          <el-form v-if="isChoose" key="1" style="margin-bottom: -10px;" :model="searchForm" ref="formData" inline
            class="global-form-label-width account-form " label-width="100px">
            <el-form-item label="" prop="specName">
              <el-input clearable v-model="searchForm.specName" placeholder="请输入品种规格" />
            </el-form-item>
            <el-form-item label="" prop="productCode">
              <el-input clearable v-model="searchForm.productCode" placeholder="请输入商品编码" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">查询</el-button>
              <el-button @click="onReset">重置</el-button>
            </el-form-item>
            <el-form-item>
              <span style="color: red;margin-top: 10px;">双击列表选择品种规格</span>
            </el-form-item>

          </el-form>
          <el-table size="mini" stripe border v-loading="loading" @row-dblclick="rowDblclick" :data="tableData">
            <el-table-column v-if="!isChoose" min-width="120" label="规格图片" prop="specImage">
              <template v-slot="{ row }">
                <el-image v-if="row.specImage" style="width: 60px; height: 60px" :src="row.specImage"
                  :preview-src-list="[row.specImage]" fit="cover" />
                <el-image v-else style="width: 60px; height: 60px" :src="YouImg" :preview-src-list="[YouImg]"
                  fit="cover" />
              </template>
            </el-table-column>
            <el-table-column min-width="120" label="粮油类型" prop="typeName"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" min-width="120" label="品种规格"
              prop="specName"></el-table-column>
            <el-table-column min-width="120" label="价格差(元)" prop="priceDiff"></el-table-column>
            <!-- <el-table-column
              min-width="160"
              label="当前单价(元)"
              prop="currentPrice"
            >
              <template v-slot="{ row, $index }">
                <el-input
                  v-if="row.showInput"
                  v-model="row.oldPrice"
                  placeholder="请输入当前单价(元)"

                ></el-input>
                <span v-else>{{ row.currentPrice }}</span>
                <span style="margin-left:10px"></span>
                <el-button
                  v-if="row.showInput"
                  type="text"
                  style="color:#333"
                  @click="closeInput($index)"
                  >取消</el-button
                >
                <el-button
                  v-if="row.showInput"
                  type="text"
                  @click="saveInput(row, $index)"
                  >保存</el-button
                >
                <el-button
                  v-if="!row.showInput"
                  type="text"
                  @click="openInput($index)"
                  >编辑</el-button
                >
              </template>
            </el-table-column> -->
            <el-table-column v-if="!isChoose" min-width="120" label="是否发布" prop="isPublished">
              <template v-slot="{ row }">
                <el-tag v-if="row.isPublished === 1" type="success">已发布</el-tag>
                <el-tag v-else type="danger">未发布</el-tag>
              </template>
            </el-table-column>
            <el-table-column v-if="!isChoose" min-width="120" label="是否展示" prop="isDisplay">
              <template v-slot="{ row }">
                <el-tag v-if="row.isDisplay == 1" type="success">是</el-tag>
                <el-tag v-else type="danger">否</el-tag>
              </template>
            </el-table-column>
            <el-table-column min-width="120" label="是否散油" prop="isBulkOil">
              <template v-slot="{ row }">
                {{ row.isBulkOil == "0" ? "否" : row.isBulkOil == "1" ? "是" : "" }}
              </template>
            </el-table-column>
            <el-table-column min-width="120" label="单位" prop="unit"></el-table-column>

            <el-table-column min-width="160" label="商品编码" prop="productCode"></el-table-column>
            <!-- 暂时隐藏列表中的用友系数列，恢复时取消此注释。
            <el-table-column v-if="!isChoose" min-width="120" label="用友系数" prop="yonyouCoefficient">
              <template v-slot="{ row }">
                {{ row.yonyouCoefficient == null ? 1 : row.yonyouCoefficient }}
              </template>
            </el-table-column>
            -->
            <el-table-column v-if="!isChoose" min-width="140" label="创建时间" prop="ctime"></el-table-column>

            <el-table-column v-if="!isChoose" min-width="100" label="排序" prop="orderNum"></el-table-column>

            <el-table-column v-if="!isChoose" width="200" label="操作" fixed="right">
              <template v-slot="{ row }">
                <!-- <el-button type="text" @click="publish(row)">{{ row.isPublished === 1 ? '下架' : '发布' }}</el-button> -->
                <el-button type="text" @click="
                  $router.push('/grainSpecifications/edit?specId=' + row.specId)
                  ">编辑</el-button>
                <el-button type="text" @click="
                  $router.push('/grainSpecifications/detail?specId=' + row.specId)
                  ">详情</el-button>
                <el-button type="text" class="del-btn" @click="onDelete(row.specId)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
    <TextDlg v-if="showTextDlg" :showDlg="showTextDlg" @closeDlg="showTextDlg = false"></TextDlg>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import TextDlg from './TextDlg.vue'
import YouImg from '@/assets/you.png'
export default {
  name: 'GrainSpecifications',
  mixins: [keepAlive],
  components: { TextDlg },
  props: {
    isChoose: {
      type: Boolean,
      default: false
    },
    // isBulkOil 是否散油： 0：否，1：是
    isBulkOil: {
      type: String,
      default: ''
    }
  },
  watch: {
    isBulkOil(val) {
      console.log('isBulkOil change', val)
      this.loadData()
    }
  },
  data() {
    return {
      tableData: [],
      typeTreeList: [],
      currentTypeId: '',
      defaultProps: {
        children: 'childNode',
        label: 'typeName',
        value: 'typeId'
      },
      YouImg,
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        specName: '',
        isBulkOil: '',
        productCode: '',
        isDisplay: ''
      },
      dialogVisible: false,
      isBulkOilArr: [
        {
          label: '否',
          value: '0'
        },
        {
          label: '是',
          value: '1'
        }
      ],
      productCodeList: [],
      showTextDlg: false
    }
  },
  created() {
    this.loadDict()
    this.loadData()
    this.loadGrainTreeList()
  },
  computed: {},
  methods: {
    loadGrainTreeList() {
      this.$axios.get(this.$apis.grainType.selectYxOilTypeByTree).then(res => {
        this.typeTreeList = [{
          typeId: '',
          typeName: '全部',
          childNode: res
        }]
      })
    },
    rowDblclick(row) {
      this.$emit('select', row)
    },
    handleNodeClick(data, node) {
      console.log('node: ', node.level)
      console.log('data: ', data)
      this.currentTypeId = data.typeId

      if (node.level === 1) {
        this.currentTypeId = ''
      }
      this.page = 1
      this.loadData()
    },
    changeText() {
      this.showTextDlg = true
    },
    saveInput(row) {
      this.$axios
        .get(this.$apis.grainSpecifications.selectYxOilSpecBySpecId, {
          params: { specId: row.specId }
        })
        .then(res => {
          this.$axios
            .post(this.$apis.grainSpecifications.updateYxOilSpec, {
              ...res,
              currentPrice: row.oldPrice
            })
            .then(() => {
              this.loadData()
            })
        })
    },
    openInput(index) {
      this.tableData[index].showInput = true
    },
    closeInput(index) {
      console.log('index: ', index)
      this.tableData[index].showInput = false
      this.tableData[index].oldPrice = this.tableData[index].currentPrice
    },
    loadDict() {
      this.$axios
        .get(this.$apis.common.selectDicByList, {
          params: { dicType: 'goodsCode' }
        })
        .then(res => {
          this.productCodeList = res.goodsCode || []
        })
    },
    loadData() {
      const params = {
        page: this.page,
        typeId: this.currentTypeId,
        ...this.searchForm,
        isBulkOil: this.isBulkOil ? this.isBulkOil : this.searchForm.isBulkOil
      }
      console.log('params', params)
      this.$axios
        .get(this.$apis.grainSpecifications.selectYxOilSpecByList, {
          params: params
        })
        .then(res => {
          res.list.forEach(item => {
            item.showInput = false
            item.oldPrice = item.currentPrice
          })
          this.tableData = res.list
          this.total = res.total
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    },
    showForm() {
      this.$router.push('/grainSpecifications/add')
    },
    onDelete(specId) {
      this.$confirm('确认删除该粮油规格?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios
          .post(this.$apis.grainSpecifications.deleteYxOilSpec, {
            specId
          })
          .then(() => {
            this.loadData()
          })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.wrap {
  display: flex;

  .left-tree {
    width: 260px;
    flex-shrink: 0;

    .title {
      background-color: #ecf1ff;
      width: 100%;
      height: 34px;
      display: flex;
      align-items: center;
      padding: 0 14px;
    }

    ::v-deep .el-tree {
      .el-tree-node {
        margin: 8px 0;
      }

      .el-tree-node__label {
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

      }
    }
  }

  .right-table {
    flex: 1;
    margin-left: 10px;
    width: 100%;
    overflow: auto;
  }

}
</style>
